import { render, staticRenderFns } from "./ManifestReviewPage.vue?vue&type=template&id=3f9bd83e&"
import script from "./ManifestReviewPage.vue?vue&type=script&lang=js&"
export * from "./ManifestReviewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports